import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { createRef } from 'react'

function generateYears (year, noOfYear) {
  const list = []
  for (let i = 0; i < 2 * noOfYear; i++) {
    list.push(year + noOfYear - i)
  }
  return list
}

class YearDropdownOptions extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      yearsList: this.props.scrollableYearDropdown
        ? generateYears(this.props.year, 10)
        : generateYears(this.props.year, 5)
    }
    this.upcomingRef = createRef()
    this.previousRef = createRef()
  }

  renderOptions = () => {
    const selectedYear = this.props.year
    const options = this.state.yearsList.map(year => (
      <button
        className='react-datepicker__year-option'
        key={year}
        ref={year}
        onClick={this.onChange.bind(this, year)}
      >
        {selectedYear === year
          ? (
            <span className='react-datepicker__year-option--selected'>✓</span>
          )
          : (
            ''
          )}
        {year}
      </button>
    ))

    options.unshift(
      <button
        className='react-datepicker__year-option'
        ref={this.upcomingRef}
        key='upcoming'
        onClick={this.incrementYears}
      >
        <p className='react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming' />
      </button>
    )
    options.push(
      <button
        className='react-datepicker__year-option'
        ref={this.previousRef}
        key='previous'
        onClick={this.decrementYears}
      >
        <p className='react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous' />
      </button>
    )
    return options
  }

  onChange = year => {
    this.props.onChange(year)
  }

  handleClickOutside = () => {
    this.props.onCancel()
  }

  shiftYears = amount => {
    this.setState(s => ({
      yearsList: s.yearsList.map(year => year + amount)
    }))
  }

  incrementYears = () => this.shiftYears(1)

  decrementYears = () => this.shiftYears(-1)

  render () {
    const dropdownClass = classNames({
      'react-datepicker__year-dropdown': true,
      'react-datepicker__year-dropdown--scrollable':
        this.props.scrollableYearDropdown
    })

    return <div className={dropdownClass}>{this.renderOptions()}</div>
  }
}

YearDropdownOptions.displayName = 'YearDropdownOptions'

YearDropdownOptions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  scrollableYearDropdown: PropTypes.bool,
  year: PropTypes.number.isRequired
}

export default YearDropdownOptions
